import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { COUNTRIES_DATA, ICountryCodes } from 'src/assets/countriesData';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { SELECTED_LANGUAGE_LS_KEY } from 'src/services/translate/languagesData';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-country-selector',
  templateUrl: './country-selector.component.html',
  styleUrls: ['./country-selector.component.scss'],
})
export class CountryPickerComponent implements OnInit {
  @ViewChild('countryPickerSB', { static: false })
  searchBar: IonSearchbar;

  @Input() selectedCountries: string[] = [];
  @Input() selectedCountry: string;

  items = [];
  filteredItems = [];

  selectedLangKey = 'en';

  constructor(
    public viewController: ModalController,
    private storageService: LocalStorageNativeService
  ) {}

  async ngOnInit() {
    this.selectedLangKey = await this.storageService.getItem(
      SELECTED_LANGUAGE_LS_KEY
    );

    if (this.selectedCountries.length) {
      this.items = Object.keys(COUNTRIES_DATA)
        .filter((key) =>
          this.selectedCountries.includes(COUNTRIES_DATA[key].alpha3Code)
        )
        .map((key) => ({ ...COUNTRIES_DATA[key], flag: key }));
    } else {
      this.items = Object.keys(COUNTRIES_DATA).map((key) => ({
        ...COUNTRIES_DATA[key],
        flag: key,
      }));
    }

    this.filteredItems = [...this.items];
  }

  ionViewDidEnter() {
    setTimeout(() => {
      this.searchBar.setFocus();
    }, 200);
  }

  select(country: ICountryCodes) {
    this.viewController.dismiss(country);
  }

  search(event: any) {
    const searchTerm = event.detail.value;
    this.filteredItems = this.items.filter(
      (item) =>
        item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
        (item.translations.es || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '') // replace accented chars
          .indexOf(searchTerm.toLowerCase()) > -1
    );
  }

  close() {
    this.viewController.dismiss();
  }
}
